module.exports = __webpack_public_path__ + "img/_54A6689.15b07e63.jpg";